@if (entry?.base?.display && isPrescribedMeds && medFormMedications?.length) {
  <div class="med-review-container">
    <h4><strong>Prescription drugs you are currently taking or have been medically advised to take:</strong></h4>
    @for (medication of medFormMedications; track medication; let i = $index) {
      <div>
        @if (i > 0) {
          <mat-divider></mat-divider>
        }
        <br>
          <div class="med-row">
            <div class="med-column">
                <div><strong>Medication</strong></div>
                <div>{{ medication.medicationName }}</div>
            </div>
            <div class="med-column">
                <div><strong>Dosage</strong></div>
                <div>{{ medication.medicationDosage }}</div>
            </div>
            <div class="med-column">
                <div><strong>Condition for which prescribed</strong></div>
                <div>{{ medication.conditionForMed }}</div>
            </div>
            <div class="med-column">
                <div><strong>Currently taking?</strong></div>
                <div>{{ medication.currentlyTaking }}</div>
            </div>
          </div>
        </div>
    }
  </div>
}
